<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <span v-show="false">这是completeNum的值：{{ completeMathodNum }}</span>
    <input
      v-show="false"
      v-model="completeMathodNum"
      id="completeMathodNum"
    />
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button> -->
    <div
      class="analysisReport_box"
      id="pdfPrint"
      :style="{ height: reportType == 1 ? '71240px' : '68500px' }"
    >
      <!-- 第二十六页 -->
      <div class="chart_box page-box">
        <!-- {{
            getReduceOrAdd(
              ZykTeacherUserVisitCase.secondTotal -
                ZykTeacherUserVisitCase.firstTotal
            )
          }} -->
        <p>
          教师用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
            getUtils_Fun(ZykTeacherUserVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{ getReduceOrAdd(
          ZykTeacherUserVisitCase.secondTotal -
          ZykTeacherUserVisitCase.firstTotal
          ) }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykTeacherUserVisitCase.dataList"
              :transverseData="ZykTeacherUserVisitCase.secondTimeTeacherDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图50 教师用户{{ nowYear }}{{ detailYearWord }}访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <!-- {{
            getReduceOrAdd(
              ZykEnterpriseUserVisitCase.secondTotal -
                ZykEnterpriseUserVisitCase.firstTotal
            )
          }} -->
        <p class="m-top150">
          企业用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
            getUtils_Fun(ZykEnterpriseUserVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{ getReduceOrAdd(
          ZykEnterpriseUserVisitCase.secondTotal -
          ZykEnterpriseUserVisitCase.firstTotal
          ) }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykEnterpriseUserVisitCase.dataList"
              :transverseData="
                ZykEnterpriseUserVisitCase.secondTimeEnterpriseDay
              "
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图51 企业用户{{ nowYear }}{{ detailYearWord }}访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <!-- {{
            getReduceOrAdd(
              ZykSocietyUserVisitCase.secondTotal -
                ZykSocietyUserVisitCase.firstTotal
            )
          }} -->
        <p class="m-top150">
          社会学习者{{ nowYear }}{{ detailYearWord }}访问资源库共{{
            getUtils_Fun(ZykSocietyUserVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{ getReduceOrAdd(
          ZykSocietyUserVisitCase.secondTotal -
          ZykSocietyUserVisitCase.firstTotal
          ) }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykSocietyUserVisitCase.dataList"
              :transverseData="ZykSocietyUserVisitCase.secondTimeSocietyDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图52 社会学习者{{ nowYear }}{{ detailYearWord }}访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
      </div>

      <!-- 第二十七页 -->
      <div class="chart_box page-box">
        <h6>
          2.1.6.5 国家级资源库{{ nowYear }}{{ detailYearWord }}课程访问情况
        </h6>
        <!-- {{
            getReduceOrAdd(
              ZykCourseVisitCase.secondTotal - ZykCourseVisitCase.firstTotal
            )
          }} -->
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库课程被访问共{{
            getUtils_Fun(ZykCourseVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{getReduceOrAdd(
          ZykCourseVisitCase.secondTotal - ZykCourseVisitCase.firstTotal
          ) }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykCourseVisitCase.dataList"
              :transverseData="ZykCourseVisitCase.secondTimeCourseDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图53 {{ nowYear }}{{ detailYearWord }}课程访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <h6 class="m-top150">
          2.1.6.6 国家级资源库{{ nowYear }}{{ detailYearWord }}资源访问情况
        </h6>
        <!-- {{
            getReduceOrAdd(
              ZykResourceVisitCase.secondTotal - ZykResourceVisitCase.firstTotal
            )
          }} -->
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库资源被访问共{{
            getUtils_Fun(ZykResourceVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{ getReduceOrAdd(
          ZykResourceVisitCase.secondTotal - ZykResourceVisitCase.firstTotal
          ) }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykResourceVisitCase.dataList"
              :transverseData="ZykResourceVisitCase.secondTimeResourceDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图54 {{ nowYear }}{{ detailYearWord }}资源访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <h5 class="m-top150">2.1.7 国家级资源库建设及应用情况排名</h5>
        <h6 style="margin-top: 0">2.1.7.1 按活跃资源量排名</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，{{countryZykCount}}个国家级资源库项目中，{{
            sourceMater2171.legendList[0]
          }}资源库的活跃资源数量最多，紧随其后的是{{
            sourceMater2171.legendList[1]
          }}资源库和{{ sourceMater2171.legendList[2] }}资源库。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight" style="height: 32rem">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="sourceMater2171.dataList"
              :transverseData="sourceMater2171.legendList"
              :colorList="colorList"
              :gridY="'4%'"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">
            图55 国家级资源库资源数排名情况（前十五名）
          </div>
        </div>
      </div>

      <!-- 第二十八页 -->
      <div class="chart_box page-box">
        <h6>2.1.7.2 按访问量排名</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，{{countryZykCount}}个国家级资源库项目中，{{
            sourceMater2172.legendList[0]
          }}资源库的访问量最多，紧随其后的是{{
            sourceMater2172.legendList[1]
          }}资源库和{{ sourceMater2172.legendList[2] }}资源库。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight" style="height: 32rem">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="sourceMater2172.dataList"
              :transverseData="sourceMater2172.legendList"
              :colorList="colorList"
              :gridY="'4%'"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">
            图56 国家级资源库访问量排名情况（前十五名）
          </div>
        </div>
        <h6 class="m-top150">2.1.7.3 按活跃用户数排名</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，{{countryZykCount}}个国家级资源库项目中，{{
            sourceMater2173.legendList[0]
          }}资源库的活跃用户数最多，紧跟其后的是{{
            sourceMater2173.legendList[1]
          }}资源库和{{ sourceMater2173.legendList[2] }}资源库。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight" style="height: 32rem">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="sourceMater2173.dataList"
              :transverseData="sourceMater2173.legendList"
              :colorList="colorList"
              :gridY="'4%'"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">
            图57 国家级资源库活跃用户排名情况（前十五名）
          </div>
        </div>
      </div>

      <!-- 第二十九页 -->
      <div class="chart_box page-box flex-box" v-if="reportType == 1">
        <div>
          <h6>2.1.7.4 {{ nowYear }}{{ detailYearWord }}综合应用排行排名</h6>
          <p>
            根据国家级资源库{{ nowYear
            }}{{
              detailYearWord
            }}建设及应用情况，取分析时间段内的访问量、建设单位中已实名但无活动的用户数、无活动资源数等多项指标进行综合排名，排前十五名和后十五名的资源库如下表所示：
          </p>
          <div class="chart_name">
            表12 {{countryZykCount}}个国家级专业教学资源库{{ nowYear
            }}{{ detailYearWord }}综合应用排名（前十五名）
          </div>
          <div class="biaoge">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <th>序号</th>
                <th>项目编号</th>
                <th>资源库名称</th>
                <th>第一主持单位</th>
              </tr>
              <tr v-if="disksNum_top.length == 0" class="nothing">
                <td colspan="4">无</td>
              </tr>
              <tr v-else v-for="(item, index) in disksNum_top" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.zykNum }}</td>
                <td>{{ item.zykName }}</td>
                <td>{{ item.firstChargeUnit }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <div class="chart_name">
            表13 {{countryZykCount}}个国家级专业教学资源库{{ nowYear
            }}{{ detailYearWord }}综合应用排名（后十五名）
          </div>
          <div class="biaoge">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <th>序号</th>
                <th>项目编号</th>
                <th>资源库名称</th>
                <th>第一主持单位</th>
              </tr>
              <tr v-if="disksNum_last.length == 0" class="nothing">
                <td colspan="4">无</td>
              </tr>
              <tr v-else v-for="(item, index) in disksNum_last" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.zykNum }}</td>
                <td>{{ item.zykName }}</td>
                <td>{{ item.firstChargeUnit }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- 第三十页 -->
      <div class="chart_box page-box flex-box">
        <h4>2.2 国家及省市校级专业教学资源库运行监测情况分析</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，职业教育专业教学资源库已纳入监测项目共计{{
            runCase.zykLevelsCount.dataList[0]
          }}个，其中国家级资源库共计{{
            runCase.zykLevelsCount.dataList[1]
          }}个，省级资源库共计{{
            runCase.zykLevelsCount.dataList[2]
          }}个，校级资源库共计{{
            runCase.zykLevelsCount.dataList[3]
          }}个，覆盖了{{
            runCase.professionCategoryNum.length - 1
          }}个专业大类。目前，已有{{ runCase.schoolBuildNum }}所职业院校和{{
            runCase.companyBuildNum
          }}家行业企业参与建设，标准化课程总量已达{{
            getUtils_Fun(runCase.standardNum)
          }}门，资源总量达{{
            getUtils_Fun(runCase.resourceNum)
          }}余条，共有注册用户{{
            getUtils_Fun(runCase.totalUserCount)
          }}余人，总访问量{{
            getUtils_Fun(runCase.totalVisitNum)
          }}次，支撑平台数达{{
            platformNum.zykPlatform
          }}个，形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设及应用情况分析如下：
        </p>
        <h5>2.2.1 用户建设及应用情况</h5>
        <p>
          当前，资源库共有注册用户{{
            getUtils_Fun(analysis.totalUserCount)
          }}余人，按用户身份类型统计，教师{{
            getUtils_Fun(analysis.teacher)
          }}余人，学生{{
            getUtils_Fun(analysis.studentTotal)
          }}余人。资源库企业用户{{ getUtils_Fun(analysis.enterprise) }}余人
          ，能够较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者用户{{
            getUtils_Fun(analysis.social)
          }}余人，努力承担面向普通劳动者免费线上培训的社会责任。资源库项目整体用户访问资源总量约{{
            getUtils_Fun(analysis.resourceModule)
          }}次、用户访问课程总量约{{
            getUtils_Fun(analysis.courseModule)
          }}次，用户互动交流次数约{{ getUtils_Fun(analysis.userModule) }}次。
        </p>
        <p>用户类型分布详情如下图所示：</p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="analysis.userMap"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'50%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">图58 资源库用户整体情况（单位：人）</div>
        </div>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="analysis.studentType"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'50%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">图59 资源库学生类型分布情况（单位：人）</div>
        </div>
      </div>

      <!-- 第三十一页 -->
      <div class="chart_box page-box">
        <h5>2.2.2 课程建设及应用情况</h5>
        <p>
          当前，资源库项目课程总量达到{{
            getUtils_Fun(courseBuild.courseNum)
          }}门，其中个性化课程{{
            getUtils_Fun(courseBuild.courseType.value[1])
          }}门，标准化课程{{
            getUtils_Fun(courseBuild.courseType.value[0])
          }}门。其中，注册学生数最多的课程名《{{
            courseBuild.courseMaxCount.name &&
            courseBuild.courseMaxCount.name.split("-")[0]
          }}》是属于{{ courseBuild.courseMaxCount.zykName }}资源库。在{{
            courseBuild.courseMaxCount.zykDiv
          }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下图所示：
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'resourcesMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="courseBuild.courseType.value"
              :transverseData="courseBuild.courseType.name"
              :colorList="colorList"
              style="height: 100%"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图60 资源库课程整体情况（单位：门）</div>
        </div>
        <h5 class="m-top150">2.2.3 资源建设及应用情况</h5>
        <p>
          资源库项目资源数量达{{
            getUtils_Fun(getResource.resourceNum)
          }}余条，资源总容量达{{
            formatValue(getResource.resourceCapacityNum / 1024 / 1024)
          }}TB,视频类资源数量最多，达到{{
            getUtils_Fun(getResource.resourceTypeMap.value[0])
          }}条。除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
            getUtils_Fun(getResource.resourceTypeMap.value[3])
          }}条虚拟仿真资源。资源访问总量已达{{
            getUtils_Fun(getResource.resourceTotal)
          }}余次
          <!-- ，其中访问次数最多的资源是“{{
            getResource.visitMaxResource.name
          }}”，属于“{{ getResource.visitMaxResource.zykName }}” -->
          。
        </p>
        <p>资源按类型分布详情如下图所示：</p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="getResource.resourceTypeMap.value"
              :transverseData="getResource.resourceTypeMap.name"
              :colorList="colorList"
              :gridY="'4%'"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图61 资源库资源整体情况（单位：条）</div>
        </div>
      </div>

      <!-- 第三十二页 -->
      <div class="chart_box page-box">
        <h5>2.2.4 各省资源库建设及应用情况</h5>
        <h6>2.2.4.1 各省资源库建设及应用情况概览</h6>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表14" : "表12" }}</span>
          各省资源库建设及应用情况概览
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>省份</th>
              <th>资源库总数</th>
              <th>素材资源总数</th>
              <th>标准化课程总数</th>
              <th>总用户数</th>
              <th>活跃教师数</th>
              <th>活跃学生数</th>
              <th>总访问量</th>
            </tr>
            <tr
              v-if="getProvince.zykProvinceClassify.length == 0"
              class="nothing"
            >
              <td colspan="9">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in getProvince.zykProvinceClassify"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province1 }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.resourceCount }}</td>
              <td>{{ item.courseCount }}</td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.totalActiveTeacherNum }}</td>
              <td>{{ item.totalActiveStudentNum }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
            <tr v-if="getProvince.zykProvinceClassify.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>{{ provinceAmount.zykCount }}</td>
              <td>{{ provinceAmount.resourceCount }}</td>
              <td>{{ provinceAmount.courseCount }}</td>
              <td>{{ provinceAmount.userCount }}</td>
              <td>{{ provinceAmount.totalActiveTeacherNum }}</td>
              <td>{{ provinceAmount.totalActiveStudentNum }}</td>
              <td>{{ provinceAmount.logNum }}</td>
            </tr>
          </table>
        </div>
        <p class="notes">
          注：“各省资源库”
          均以该资源库的第一主持院校所在地来确定该资源库所归属的省份。
        </p>
      </div>

      <!-- 第三十三页 -->
      <div class="chart_box page-box">
        <h6>2.2.4.2 各省用户建设及应用情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
            getUtils_Fun(getProvinceUser.zykUserNum)
          }}人，其中注册用户最多的是{{
            changeCity(getProvinceUser.maxRegisteredUsersProvince.province)
          }}资源库，达{{
            getUtils_Fun(getProvinceUser.maxRegisteredUsersProvince.num)
          }}人；交流互动次数累计{{
            getUtils_Fun(getProvinceUser.forumLogProvinceNumTotal)
          }}次，互动交流频次最多的是{{
            changeCity(getProvinceUser.maxInteractiveUsersProvince.province)
          }}资源库，达{{
            getUtils_Fun(getProvinceUser.maxInteractiveUsersProvince.num)
          }}次；活跃用户总人数{{
            getUtils_Fun(getProvinceUser.provinceStatusActiveUserTotal)
          }}人，活跃用户数最多的是{{
            changeCity(getProvinceUser.provinceStatusActiveUser.province)
          }}资源库，共{{
            getUtils_Fun(getProvinceUser.provinceStatusActiveUser.activeNum)
          }}人。 具体各省资源库用户按照活跃用户数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表15" : "表13" }}</span>
          各省资源库活跃用户数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源库数（个）</th>
              <th>注册用户数（人）</th>
              <th>活跃用户数（人）</th>
              <th>交流互动量（次）</th>
            </tr>
            <tr
              v-if="getProvinceUser.provinceStatusActiveUserRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in getProvinceUser.provinceStatusActiveUserRank.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.activeNum }}</td>
              <td>{{ item.formun }}</td>
            </tr>
          </table>
        </div>
        <div class="echarts-box m-top150">
          <div class="standards_content echartsHeight" style="height: 1000px">
            <distributionChart
              :refId="'userTalk'"
              :datas="getProvinceUser.provinceLogTotal"
              :color="mapcolorList"
              :isExportFont="18"
              :zoom="true"
            ></distributionChart>
          </div>
          <div class="chart_name">图62 各省资源库访问热力图</div>
        </div>
      </div>

      <!-- 第三十四页 -->
      <div class="chart_box page-box">
        <h6>2.2.4.3 各省课程建设及应用情况</h6>
        <p v-if="CourseBuildAndAnalysis.courseRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，资源库建设课程总计{{
            getUtils_Fun(CourseBuildAndAnalysis.zykBuildCourseCount)
          }}门，其中建设课程数量最多的是{{
            CourseBuildAndAnalysis.courseRank[0].name
          }}资源库，有{{
            getUtils_Fun(CourseBuildAndAnalysis.courseRank[0].num)
          }}门；标准化课程数累计有{{
            getUtils_Fun(CourseBuildAndAnalysis.standardIntValue)
          }}门， 标准化课程数最多的是{{
            CourseBuildAndAnalysis.standard.name
          }}资源库，共{{
            CourseBuildAndAnalysis.standard.value
          }}门，个性化课程数累计有{{
            getUtils_Fun(CourseBuildAndAnalysis.personalizationIntlValue)
          }}门，个性化课程数最多的{{
            CourseBuildAndAnalysis.personality.name
          }}资源库，有{{
            getUtils_Fun(CourseBuildAndAnalysis.personality.value)
          }}门。 具体各省按照总课程数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表16" : "表14" }}</span
          >各省资源库总课程数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>标准化课程数</th>
              <th>个性化课程数</th>
              <th>总课程数</th>
            </tr>
            <tr
              v-if="CourseBuildAndAnalysis.courseRank.length == 0"
              class="nothing"
            >
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in CourseBuildAndAnalysis.courseRank.slice(
                0,
                15
              )"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.snum }}</td>
              <td>{{ item.pnum }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h6 class="m-top150">2.2.4.4 各省资源建设及应用情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，资源库建设资源累计达{{
            getUtils_Fun(ZyBuildAndAnalysis.resourceBuildCount)
          }}条，其中建设资源数量最多的是{{
            changeCity(ZyBuildAndAnalysis.resourceBuildProvinceMax.province)
          }}资源库，有{{
            (ZyBuildAndAnalysis.resourceBuildProvinceMax.num / 10000).toFixed(
              2
            )
          }}万条。各省访问资源的总量达{{
            getUtils_Fun(ZyBuildAndAnalysis.resourceTotal)
          }}次，访问资源总量最多的是{{
            changeCity(ZyBuildAndAnalysis.resourceProvinceVisitMax.province)
          }}资源库。具体各省资源库资源建设按访问数情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表17" : "表15" }}</span>
          各省资源库资源数情况排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源数（条）</th>
              <th>资源量（TB）</th>
              <th>访问量（次）</th>
            </tr>
            <tr
              v-if="ZyBuildAndAnalysis.resourceProvinceStateRank.length == 0"
              class="nothing"
            >
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in ZyBuildAndAnalysis.resourceProvinceStateRank.slice(0, 15)"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province1 }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.disksNum }}</td>
              <td>{{ item.log }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第三十五页 -->
      <div class="chart_box page-box">
        <h5>2.2.5 {{ nowYear }}{{ detailYearWord }}资源库总体建设及应用情况</h5>
        <h6 style="margin-top: 0">2.2.5.1 资源库用户新增情况</h6>
        <div class="flex-box">
          <div>
            <p>
              {{ nowYear }}{{ detailYearWord }}资源库学生新增共{{
                getUtils_Fun(ZykStudentUserNewAddCase.secondTotal)
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="ZykStudentUserNewAddCase.dataList"
                  :transverseData="
                    ZykStudentUserNewAddCase.studentSecondTimeDay
                  "
                  :colorList="colorList"
                  :legendList="[nowYear]"
                  :innerText="'单位：人'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">
                图63 {{ nowYear }}{{ detailYearWord }}资源库学生新增情况
              </div>
            </div>
          </div>
          <div>
            <p>
              {{ nowYear }}{{ detailYearWord }}资源库教师新增共{{
                getUtils_Fun(ZykTeacherUserNewAddCase.secondTotal)
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="ZykTeacherUserNewAddCase.dataList"
                  :transverseData="
                    ZykTeacherUserNewAddCase.secondTimeTeacherDay
                  "
                  :colorList="colorList"
                  :legendList="[nowYear]"
                  :innerText="'单位：人'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">
                图64 {{ nowYear }}{{ detailYearWord }}资源库教师新增情况
              </div>
            </div>
          </div>
          <div>
            <p>
              {{ nowYear }}{{ detailYearWord }}资源库社会学习者新增共{{
                getUtils_Fun(ZykSocietyUserNewAddCase.secondTotal)
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="ZykSocietyUserNewAddCase.dataList"
                  :transverseData="
                    ZykSocietyUserNewAddCase.secondTimeSocietyDay
                  "
                  :colorList="colorList"
                  :legendList="[nowYear]"
                  :innerText="'单位：人'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">
                图65 {{ nowYear }}{{ detailYearWord }}资源库社会学习者新增情况
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三十六页 -->
      <div class="chart_box page-box">
        <p>
          {{ nowYear }}{{ detailYearWord }}资源库企业用户新增共{{
            getUtils_Fun(ZykEnterpriseUserNewAddCase.secondTotal)
          }}人。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykEnterpriseUserNewAddCase.dataList"
              :transverseData="
                ZykEnterpriseUserNewAddCase.secondTimeEnterpriseDay
              "
              :colorList="colorList"
              :legendList="[nowYear]"
              :innerText="'单位：人'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图66 {{ nowYear }}{{ detailYearWord }}资源库企业用户新增情况
          </div>
        </div>
        <h6 class="m-top150">2.2.5.2 资源库资源新增情况</h6>
        <p>
          {{ nowYear }}{{ detailYearWord }}资源库素材资源新增共{{
            getUtils_Fun(getZykResourceNewAddCase.secondTotal)
          }}条。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="getZykResourceNewAddCase.resourceDistribution"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'50%'"
              :showValue="true"
              :unit="'条'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">
            图67 {{ nowYear }}{{ detailYearWord }}资源库新增资源类型分布情况
          </div>
          <div class="standards_content echartsHeight m-top150">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="getZykResourceNewAddCase.dataList"
              :transverseData="getZykResourceNewAddCase.secondTimeResourceDay"
              :colorList="colorList"
              :legendList="[nowYear]"
              :innerText="'单位：条'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图68 {{ nowYear }}{{ detailYearWord }}资源库素材资源新增情况
          </div>
        </div>
      </div>

      <!-- 第三十七页 -->
      <div class="chart_box page-box">
        <div>
          <h6>2.2.5.3 资源库课程新增情况</h6>
          <p>
            {{ nowYear }}{{ detailYearWord }}资源库课程新增共{{
              getZykCourseNewAddCase.secondTotal
            }}门，其中标准化课程{{
              getZykCourseNewAddCase.sNum
            }}门，个性化课程{{ getZykCourseNewAddCase.pNum }}门。
          </p>
          <div class="echarts-box">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykCourseNewAddCase.dataList"
                :transverseData="getZykCourseNewAddCase.secondTimeCourseDay"
                :colorList="colorList"
                :legendList="[nowYear]"
                :innerText="'单位：门'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图69 {{ nowYear }}{{ detailYearWord }}资源库课程新增情况
            </div>
          </div>
        </div>
        <h6 class="m-top150">2.2.5.4 资源库用户访问情况</h6>
        <p>
          {{ nowYear }}{{ detailYearWord }}资源库累计登录用户{{
            getUtils_Fun(allLevelTotalLoginUserNum)
          }}人，累计访问{{
            getUtils_Fun(zykTotalVisit)
          }}次。各类型用户日访问走势如下图所示：
        </p>
        <div class="flex-box">
          <div>
            <p>
              学生用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
                getUtils_Fun(getZykStudentUserVisitCase.secondTotal)
              }}次。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="getZykStudentUserVisitCase.dataList"
                  :transverseData="
                    getZykStudentUserVisitCase.secondTimeStudentDay
                  "
                  :colorList="colorList"
                  :legendList="[nowYear]"
                  :innerText="'单位：次'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">
                图70 {{ nowYear }}{{ detailYearWord }}资源库学生用户访问情况
              </div>
            </div>
          </div>
          <div>
            <p>
              教师用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
                getUtils_Fun(getZykTeacherUserVisitCase.secondTotal)
              }}次。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="getZykTeacherUserVisitCase.dataList"
                  :transverseData="
                    getZykTeacherUserVisitCase.secondTimeTeacherDay
                  "
                  :colorList="colorList"
                  :legendList="[nowYear]"
                  :innerText="'单位：次'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">
                图71 {{ nowYear }}{{ detailYearWord }}资源库教师用户访问情况
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三十八页 -->
      <div class="chart_box page-box flex-box">
        <div>
          <p>
            企业用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
              getUtils_Fun(getZykEnterpriseUserVisitCase.secondTotal)
            }}次。
          </p>
          <div class="echarts-box">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykEnterpriseUserVisitCase.dataList"
                :transverseData="
                  getZykEnterpriseUserVisitCase.secondTimeEnterpriseDay
                "
                :colorList="colorList"
                :legendList="[nowYear]"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图72 {{ nowYear }}{{ detailYearWord }}资源库企业用户访问情况
            </div>
          </div>
        </div>
        <div>
          <p>
            社会学习者{{ nowYear }}{{ detailYearWord }}访问资源库共{{
              getUtils_Fun(getZykSocietyUserVisitCase.secondTotal)
            }}次。
          </p>
          <div class="echarts-box">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykSocietyUserVisitCase.dataList"
                :transverseData="
                  getZykSocietyUserVisitCase.secondTimeSocietyDay
                "
                :colorList="colorList"
                :legendList="[nowYear]"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图73 {{ nowYear }}{{ detailYearWord }}资源库社会学习者访问情况
            </div>
          </div>
        </div>
        <div>
          <h6>2.2.5.5 资源库课程访问情况</h6>
          <p>
            {{ nowYear }}{{ detailYearWord }}资源库课程被访问共{{
              getUtils_Fun(getZykCourseVisitCase.secondTotal)
            }}次。
          </p>
          <div class="echarts-box">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykCourseVisitCase.dataList"
                :transverseData="getZykCourseVisitCase.secondTimeCourseDay"
                :colorList="colorList"
                :legendList="[nowYear]"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图74 {{ nowYear }}{{ detailYearWord }}资源库课程被访问情况
            </div>
          </div>
        </div>
      </div>

      <!-- 第三十九页 -->
      <div class="chart_box page-box">
        <h6>2.2.5.6 资源库资源访问情况</h6>
        <p>
          {{ nowYear }}{{ detailYearWord }}资源库资源被访问共{{
            getUtils_Fun(getZykResourceVisitCase.secondTotal)
          }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight" style="height: 35rem">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="getZykResourceVisitCase.dataList"
              :transverseData="getZykResourceVisitCase.secondTimeResourceDay"
              :colorList="colorList"
              :legendList="[nowYear]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图75 {{ nowYear }}{{ detailYearWord }}资源库资源被访问情况
          </div>
        </div>
        <h5 class="m-top150">2.2.6 资源库建设及应用情况排名</h5>
        <h6 style="margin-top: 0">2.2.6.1 活跃资源量排名</h6>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表18" : "表16" }}</span>
          活跃资源量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>第一主持单位</th>
              <th>级别</th>
              <th>数量</th>
            </tr>
            <tr v-if="countryZykActiveResourceRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in countryZykActiveResourceRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第四十页 -->
      <div class="chart_box page-box">
        <h6>2.2.6.2 访问量排名</h6>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表19" : "表17" }}</span>
          访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>专业名称</th>
              <th>第一主持单位</th>
              <th>级别</th>
              <th>访问量</th>
            </tr>
            <tr v-if="zykLogRankList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in zykLogRankList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
          </table>
        </div>
        <h6 class="m-top150">2.2.6.3 活跃用户数排名</h6>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表20" : "表18" }}</span>
          活跃用户数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>专业名称</th>
              <th>第一主持单位</th>
              <th>级别</th>
              <th>数量</th>
            </tr>
            <tr v-if="zykActiveUserRankList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in zykActiveUserRankList"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第四十一页 -->
      <div class="chart_box page-box">
        <div class="division">3. 在线精品课程运行监测情况分析</div>
        <p v-if="CourseYearRunAnalysis.onlineCourseLevelNums.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，在线精品课程共纳入监测{{
            CourseYearRunAnalysis.onlineCourseNum
          }}门，其中，{{
            CourseYearRunAnalysis.onlineCourseLevelNums[1].kname
          }}课程有{{ CourseYearRunAnalysis.onlineCourseLevelNums[1].num }}门，{{
            CourseYearRunAnalysis.onlineCourseLevelNums[0].kname
          }}课程有{{ CourseYearRunAnalysis.onlineCourseLevelNums[0].num }}门，{{
            CourseYearRunAnalysis.onlineCourseLevelNums[2].kname
          }}课程有{{
            CourseYearRunAnalysis.onlineCourseLevelNums[2].num
          }}门。目前，在线精品课程已有{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[7]
          }}所院校和{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[5]
          }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(
              CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[6]
            )
          }}次，总开课期数为{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[0]
          }}期，总课时数为{{
            getUtils_Fun(
              CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[2]
            )
          }}课时，总选课人数{{
            getUtils_Fun(
              CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[4]
            )
          }}人，总互动次数{{
            getUtils_Fun(
              CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[1]
            )
          }}次。
        </p>
        <p>具体建设及应用情况分析如下：</p>
        <h4 style="margin-top: 50px">3.1 各省建设课程情况</h4>
        <p v-if="ProvinceBuildCourseNum.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
            ProvinceBuildCourseNum[0].name
          }}省建设课程数量最多，共{{
            ProvinceBuildCourseNum[0].value
          }}门，具体各省建设课程数量分布如图所示：
        </p>
        <div class="echarts-box" style="margin-top: 30px">
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="ProvinceBuildCourseNum"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'20%'"
              :showValue="true"
              :unit="'门'"
              :legendBackgroundColor="true"
              :legendLeft="'40%'"
              :circleSize="80"
              :seriesRight="'60%'"
            ></circularChart>
          </div>
          <div class="chart_name">图76 各省建设课程数量</div>
        </div>
        <h4 class="m-top150">3.2 课程归属专业大类情况</h4>
        <p v-if="BigClassCourseNum.dataList.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程覆盖{{
            BigClassCourseNum.dataList.length - 1
          }}个专业大类。从专业大类分布看，{{
            BigClassCourseNum.dataList[0].name
          }}的课程最多，一共{{
            BigClassCourseNum.dataList[0].value
          }}门课程，占比达{{
            (
              (BigClassCourseNum.dataList[0].value / BigClassCourseNum.total) *
              100
            ).toFixed(2)
          }}%，具体在线精品课分布如图所示：
        </p>
        <div class="echarts-box" style="margin-top: 30px">
          <div class="standards_content echartsHeight">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="BigClassCourseNum.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'20%'"
              :showValue="true"
              :unit="'门'"
              :legendBackgroundColor="true"
              :legendLeft="'40%'"
              :circleSize="80"
              :seriesRight="'60%'"
            ></circularChart>
          </div>
          <div class="chart_name">图77 归属专业大类分布情况</div>
        </div>
      </div>

      <!-- 第四十二页 -->
      <div class="chart_box page-box">
        <h4>3.3 在线精品课访问情况</h4>
        <p v-if="OnlineCourseVisitNum.onlineCourseVisitRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，在线精品课程共计访问量{{
            getUtils_Fun(OnlineCourseVisitNum.onlineCourseTotalVisit)
          }}，访问量最高的课程是{{
            OnlineCourseVisitNum.onlineCourseVisitRank[0].schoolname
          }}的《{{
            OnlineCourseVisitNum.onlineCourseVisitRank[0].name
          }}》，访问量排名（前十五名）的课程信息如表18所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表21" : "表19" }}</span>
          访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th style="width: 400px">课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>访问量</th>
            </tr>
            <tr
              v-if="OnlineCourseVisitNum.onlineCourseVisitRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in OnlineCourseVisitNum.onlineCourseVisitRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.4 在线精品课开课情况</h4>
        <p v-if="OnlineCourseOpenNum.onlineCourseOpenRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，在线精品课程共计开课期数{{
            OnlineCourseOpenNum.onlineCourseTotalOpenNum
          }}期，开课期数最多的课程是{{
            OnlineCourseOpenNum.onlineCourseOpenRank[0].schoolname
          }}的《{{
            OnlineCourseOpenNum.onlineCourseOpenRank[0].name
          }}》，开课期数（前十五名）的课程信息如表19所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表22" : "表20" }}</span>
          开课期数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>开课期数</th>
            </tr>
            <tr
              v-if="OnlineCourseOpenNum.onlineCourseOpenRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in OnlineCourseOpenNum.onlineCourseOpenRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第四十三页 -->
      <div class="chart_box page-box" style="padding-top: 5%">
        <h4>3.5 在线精品课程选课情况</h4>
        <p v-if="OnlineCourseSelectNum.onlineCourseSelectRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，在线精品课程共计选课人数{{
            getUtils_Fun(OnlineCourseSelectNum.onlineCourseTotalSelectNum)
          }}人，选课人数最多的课程是{{
            OnlineCourseSelectNum.onlineCourseSelectRank[0].schoolname
          }}的《{{
            OnlineCourseSelectNum.onlineCourseSelectRank[0].name
          }}》，选课人数排名（前十五名）的课程信息如表20所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表23" : "表21" }}</span>
          选课人数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>选课人数</th>
            </tr>
            <tr
              v-if="OnlineCourseSelectNum.onlineCourseSelectRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in OnlineCourseSelectNum.onlineCourseSelectRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <div class="division" style="margin: 20px 0">
          4 视频公开课运行监测情况分析
        </div>
        <p v-if="VideoCourseRunAnalysis.videoCourseCoreIndicator">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，视频公开课共纳入监测{{
            VideoCourseRunAnalysis.videoCourseNunForType.value[4]
          }}门，其中， 国家规范教材有{{
            VideoCourseRunAnalysis.videoCourseNunForType.value[0]
          }}门、课程思政示范课有{{
            VideoCourseRunAnalysis.videoCourseNunForType.value[1]
          }}门、公共基础课有{{
            VideoCourseRunAnalysis.videoCourseNunForType.value[2]
          }}门、教学能力比赛比赛获奖作品有{{
            VideoCourseRunAnalysis.videoCourseNunForType.value[3]
          }}门。 目前，视频公开课已有{{
            VideoCourseRunAnalysis.videoCourseCoreIndicator["参建院校"]
          }}所院校和{{
            VideoCourseRunAnalysis.videoCourseCoreIndicator["教师参建人次"]
          }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(
              VideoCourseRunAnalysis.videoCourseCoreIndicator["总访问量"]
            )
          }}次，总开课期数为{{
            VideoCourseRunAnalysis.videoCourseCoreIndicator["总开课期数"]
          }}期，总课时数为{{
            getUtils_Fun(
              VideoCourseRunAnalysis.videoCourseCoreIndicator["总课时数"]
            )
          }}课时，总选课人数{{
            getUtils_Fun(
              VideoCourseRunAnalysis.videoCourseCoreIndicator["总选课人数"]
            )
          }}人。
        </p>
        <p>具体建设及应用情况如下：</p>
        <h4 style="margin: 20px 0">4.1 各省视频公开课建设情况</h4>
        <p v-if="ProvinceVideoCourseBuild.videoCourseProvinceRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，视频公开课课程共纳入监测{{
            ProvinceVideoCourseBuild.videoCourseNum
          }}门，其中，{{
            ProvinceVideoCourseBuild.videoCourseProvinceRank[0].province
          }}省建设课程数量最多，共{{
            ProvinceVideoCourseBuild.videoCourseProvinceRank[0].total
          }}门，具体各省建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表24" : "表22" }}</span>
          各省建设视频公开课数量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>建设课程数</th>
              <th>选课人数</th>
            </tr>
            <tr
              v-if="
                ProvinceVideoCourseBuild.videoCourseProvinceRank.length == 0
              "
              class="nothing"
            >
              <td colspan="4">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in ProvinceVideoCourseBuild.videoCourseProvinceRank.slice(
                0,
                15
              )"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total }}</td>
              <td>{{ item.studynum }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第四十四页 -->
      <div class="chart_box page-box">
        <h4>4.2 视频公开课访问情况</h4>
        <p v-if="VideoCourseVisit.videoCourseVisitRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，视频公开课共计访问量{{
            getUtils_Fun(VideoCourseVisit.videoCourseTotalVisitNum)
          }}，访问量最高的课程是{{
            VideoCourseVisit.videoCourseVisitRank[0].schoolname
          }}的《{{
            VideoCourseVisit.videoCourseVisitRank[0].name
          }}》，访问量排名（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表25" : "表23" }}</span>
          视频公开课访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>访问量</th>
            </tr>
            <tr
              v-if="VideoCourseVisit.videoCourseVisitRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in VideoCourseVisit.videoCourseVisitRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">4.3 视频公开课选课情况</h4>
        <p v-if="VideoCourseSelect.videoCourseSelectRank.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，视频公开课共计选课人数{{
            getUtils_Fun(VideoCourseSelect.videoCourseTotalSelectNum)
          }}人，选课人数最多的课程是{{
            VideoCourseSelect.videoCourseSelectRank[0].schoolname
          }}的《{{
            VideoCourseSelect.videoCourseSelectRank[0].name
          }}》，选课人数（前十五名）的课程信息如下表所示：
        </p>
        <div class="chart_name">
          <span>{{ reportType == 1 ? "表26" : "表24" }}</span>
          视频公开课选课人数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>选课人数</th>
            </tr>
            <tr
              v-if="VideoCourseSelect.videoCourseSelectRank.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in VideoCourseSelect.videoCourseSelectRank"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 装备制造大类、交通运输大类 -->
      <div class="chart_box page-box" style="padding-top: 3%">
        <p>附件一：各专业大类资源库建设及应用详情</p>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.装备制造大类.value.length === 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .装备制造大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.装备制造大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>装备制造大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.装备制造大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.装备制造大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.装备制造大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.装备制造大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.装备制造大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.装备制造大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.装备制造大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top70">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.交通运输大类.value.length === 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .交通运输大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.交通运输大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>交通运输大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.交通运输大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.交通运输大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.交通运输大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.交通运输大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.交通运输大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.交通运输大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.交通运输大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 财经商贸大类、电子与信息大类 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.财经商贸大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .财经商贸大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.财经商贸大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>财经商贸大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.财经商贸大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.财经商贸大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.财经商贸大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.财经商贸大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.财经商贸大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.财经商贸大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.财经商贸大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.电子与信息大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .电子与信息大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.电子与信息大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>电子与信息大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.电子与信息大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.电子与信息大类.totalUser }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.电子与信息大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.电子与信息大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.电子与信息大类.totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.电子与信息大类.standardCourse
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.电子与信息大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 土木建筑大类、农林牧渔大类 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.土木建筑大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .土木建筑大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.土木建筑大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>土木建筑大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.土木建筑大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.土木建筑大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.土木建筑大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.土木建筑大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.土木建筑大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.土木建筑大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.土木建筑大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.农林牧渔大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .农林牧渔大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.农林牧渔大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>农林牧渔大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.农林牧渔大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.农林牧渔大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.农林牧渔大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.农林牧渔大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.农林牧渔大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.农林牧渔大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.农林牧渔大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 文化艺术大类、医药卫生大类 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.文化艺术大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .文化艺术大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.文化艺术大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>文化艺术大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.文化艺术大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.文化艺术大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.文化艺术大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.文化艺术大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.文化艺术大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.文化艺术大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.文化艺术大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.医药卫生大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .医药卫生大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.医药卫生大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>医药卫生大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.医药卫生大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.医药卫生大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.医药卫生大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.医药卫生大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.医药卫生大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.医药卫生大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.医药卫生大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 轻工纺织大类、能源动力与材料大类、食品药品与粮食大类 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.轻工纺织大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .轻工纺织大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.轻工纺织大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>轻工纺织大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.轻工纺织大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.轻工纺织大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.轻工纺织大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.轻工纺织大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.轻工纺织大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.轻工纺织大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.轻工纺织大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.能源动力与材料大类.value
                  .length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .能源动力与材料大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.能源动力与材料大类.value.length >
                0
              "
            >
              <td>合计</td>
              <td>能源动力与材料大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{
                  allProfessionAnalysisTableList.能源动力与材料大类.totalVisit
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.能源动力与材料大类.totalUser
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.能源动力与材料大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.能源动力与材料大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.能源动力与材料大类
                    .totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.能源动力与材料大类
                    .standardCourse
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.能源动力与材料大类.totalCourse
                }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.食品药品与粮食大类.value
                  .length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .食品药品与粮食大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.食品药品与粮食大类.value.length >
                0
              "
            >
              <td>合计</td>
              <td>食品药品与粮食大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{
                  allProfessionAnalysisTableList.食品药品与粮食大类.totalVisit
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.食品药品与粮食大类.totalUser
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.食品药品与粮食大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.食品药品与粮食大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.食品药品与粮食大类
                    .totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.食品药品与粮食大类
                    .standardCourse
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.食品药品与粮食大类.totalCourse
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 旅游大类、资源环境与安全大类、公共管理与服务大类、生物与化工大类 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="allProfessionAnalysisTableList.旅游大类.value.length == 0"
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList.旅游大类
                .value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr v-if="allProfessionAnalysisTableList.旅游大类.value.length > 0">
              <td>合计</td>
              <td>旅游大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ allProfessionAnalysisTableList.旅游大类.totalVisit }}</td>
              <td>{{ allProfessionAnalysisTableList.旅游大类.totalUser }}</td>
              <td>{{ allProfessionAnalysisTableList.旅游大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.旅游大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.旅游大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.旅游大类.standardCourse }}
              </td>
              <td>{{ allProfessionAnalysisTableList.旅游大类.totalCourse }}</td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.资源环境与安全大类.value
                  .length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .资源环境与安全大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.资源环境与安全大类.value.length >
                0
              "
            >
              <td>合计</td>
              <td>资源环境与安全大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{
                  allProfessionAnalysisTableList.资源环境与安全大类.totalVisit
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.资源环境与安全大类.totalUser
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.资源环境与安全大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.资源环境与安全大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.资源环境与安全大类
                    .totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.资源环境与安全大类
                    .standardCourse
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.资源环境与安全大类.totalCourse
                }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.公共管理与服务大类.value
                  .length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .公共管理与服务大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.公共管理与服务大类.value.length >
                0
              "
            >
              <td>合计</td>
              <td>公共管理与服务大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{
                  allProfessionAnalysisTableList.公共管理与服务大类.totalVisit
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公共管理与服务大类.totalUser
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公共管理与服务大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公共管理与服务大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公共管理与服务大类
                    .totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公共管理与服务大类
                    .standardCourse
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公共管理与服务大类.totalCourse
                }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.生物与化工大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .生物与化工大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.生物与化工大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>生物与化工大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.生物与化工大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.生物与化工大类.totalUser }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.生物与化工大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.生物与化工大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.生物与化工大类.totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.生物与化工大类.standardCourse
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.生物与化工大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 新闻传播大类、公安与司法大类、教育与体育大类、水利大类、其他 -->
      <div class="chart_box page-box">
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.新闻传播大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .新闻传播大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.新闻传播大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>新闻传播大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.新闻传播大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.新闻传播大类.totalUser }}
              </td>
              <td>{{ allProfessionAnalysisTableList.新闻传播大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.新闻传播大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.新闻传播大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.新闻传播大类.standardCourse }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.新闻传播大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.公安与司法大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .公安与司法大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.公安与司法大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>公安与司法大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.公安与司法大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公安与司法大类.totalUser }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公安与司法大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公安与司法大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公安与司法大类.totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.公安与司法大类.standardCourse
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.公安与司法大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.教育与体育大类.value.length == 0
              "
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList
                .教育与体育大类.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr
              v-if="
                allProfessionAnalysisTableList.教育与体育大类.value.length > 0
              "
            >
              <td>合计</td>
              <td>教育与体育大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>
                {{ allProfessionAnalysisTableList.教育与体育大类.totalVisit }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.教育与体育大类.totalUser }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.教育与体育大类.student }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.教育与体育大类.teacher }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.教育与体育大类.totalResource
                }}
              </td>
              <td>
                {{
                  allProfessionAnalysisTableList.教育与体育大类.standardCourse
                }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.教育与体育大类.totalCourse }}
              </td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="allProfessionAnalysisTableList.水利大类.value.length == 0"
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList.水利大类
                .value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr v-if="allProfessionAnalysisTableList.水利大类.value.length > 0">
              <td>合计</td>
              <td>水利大类</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ allProfessionAnalysisTableList.水利大类.totalVisit }}</td>
              <td>{{ allProfessionAnalysisTableList.水利大类.totalUser }}</td>
              <td>{{ allProfessionAnalysisTableList.水利大类.student }}</td>
              <td>{{ allProfessionAnalysisTableList.水利大类.teacher }}</td>
              <td>
                {{ allProfessionAnalysisTableList.水利大类.totalResource }}
              </td>
              <td>
                {{ allProfessionAnalysisTableList.水利大类.standardCourse }}
              </td>
              <td>{{ allProfessionAnalysisTableList.水利大类.totalCourse }}</td>
            </tr>
          </table>
        </div>
        <div class="biaoge m-top100">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course annex-table"
          >
            <tr>
              <th>序号</th>
              <th>专业大类名称</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程</th>
              <th>课程总数</th>
            </tr>
            <tr
              v-if="allProfessionAnalysisTableList.其他.value.length == 0"
              class="nothing"
            >
              <td colspan="12">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in allProfessionAnalysisTableList.其他.value"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr v-if="allProfessionAnalysisTableList.其他.value.length > 0">
              <td>合计</td>
              <td>其他</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ allProfessionAnalysisTableList.其他.totalVisit }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.totalUser }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.student }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.teacher }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.totalResource }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.standardCourse }}</td>
              <td>{{ allProfessionAnalysisTableList.其他.totalCourse }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图

export default {
  components: {
    circularChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
  },
  data() {
    return {
      countryZykCount:203,
      completeMathodNum: 0, //统计接口数量
      allLevelTotalLoginUserNum: 0, //2.2.5.4 累计登录用户
      zykTotalVisit: 0, //2.2.5.4 累计点击数
      year: "",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#04F995",
        "#E8FF6C",
        "#00EEF2",
        "#0DA1FD",
        "#F50512",
      ], // 柱状图或折线图的颜色
      mapcolorList: ["#ffd9d9"],
      header: {
        zykName: "",
        zykNum: "",
      },

      ZykTeacherUserVisitCase: {}, //2.1.6.4 国家级资源库用户访问情况-教师用户
      ZykEnterpriseUserVisitCase: {}, //2.1.6.4 国家级资源库用户访问情况-企业用户
      ZykSocietyUserVisitCase: {}, //2.1.6.4 国家级资源库用户访问情况-社会学习者
      ZykCourseVisitCase: {}, //2.1.6.5 国家级资源库课程访问情况

      ZykResourceVisitCase: {}, //2.1.6.6 国家级资源库资源访问情况

      // 2.1.7.1 按资源量维度排名
      sourceMater2171: {
        dataList: [],
        legendList: [],
      },
      // 2.1.7.2 按访问量维度排名
      sourceMater2172: {
        dataList: [],
        legendList: [],
      },
      // 2.1.7.3 按活跃用户数排名
      sourceMater2173: {
        dataList: [],
        legendList: [],
      },
      disksNum_top: [], //2.1.7.4 前15名
      disksNum_last: [], //2.1.7.4 后15名

      //2.2 国家及省市校级专业教学资源库运行监测情况分析
      runCase: {
        zykLevelsCount: {
          dataList: [],
        },
        professionCategoryNum: [],
      },
      platformNum: {}, //平台数
      analysis: {}, //2.2.1 用户建设及应用情况

      //2.2.2 课程建设及应用情况
      courseBuild: {
        courseType: {
          value: [],
        },
        courseMaxCount: {},
      },

      //2.2.3 资源建设及应用情况
      getResource: {
        resourceTypeMap: {
          value: [],
        },
        visitMaxResource: {},
      },

      //2.2.4.1 各省资源库建设及应用情况概览
      getProvince: {
        zykProvinceClassify: [],
      },
      provinceAmount: {
        zykCount: 0,
        resourceCount: 0,
        courseCount: 0,
        userCount: 0,
        totalActiveTeacherNum: 0,
        totalActiveStudentNum: 0,
        logNum: 0,
      },
      //2.2.4.2 各省用户建设及应用情况
      getProvinceUser: {
        maxRegisteredUsersProvince: {},
        maxInteractiveUsersProvince: {},
        provinceStatusActiveUser: {},
        provinceStatusActiveUserRank: [],
      },
      //2.2.4.3 各省课程建设及应用情况
      CourseBuildAndAnalysis: {
        courseRank: [],
        standard: {},
        personality: {},
      },
      //2.2.4.4 各省资源建设及应用情况
      ZyBuildAndAnalysis: {
        resourceBuildProvinceMax: {},
        resourceProvinceVisitMax: {},
        resourceProvinceStateRank: [],
      },

      ZykStudentUserNewAddCase: {}, //2.2.5.1 资源库用户新增情况-学生用户
      ZykTeacherUserNewAddCase: {}, //2.2.5.1 资源库用户新增情况-教师用户
      ZykEnterpriseUserNewAddCase: {}, //2.2.5.1 资源库用户新增情况-企业用户
      ZykSocietyUserNewAddCase: {}, //2.2.5.1 资源库用户新增情况-社会学习者

      getZykResourceNewAddCase: {
        resourceDistribution: [],
      }, //2.2.5.2 资源库资源新增情况
      getZykCourseNewAddCase: {}, //2.2.5.3 资源库课程新增情况

      getZykStudentUserVisitCase: {}, //2.2.5.4 资源库用户访问情况-学生用户
      getZykTeacherUserVisitCase: {}, //2.2.5.4 资源库用户访问情况-教师用户
      getZykEnterpriseUserVisitCase: {}, //2.2.5.4 资源库用户访问情况-企业用户
      getZykSocietyUserVisitCase: {}, //2.2.5.4 资源库用户访问情况-社会学习者

      getZykCourseVisitCase: {}, //2.2.5.5 资源库课程访问情况
      getZykResourceVisitCase: {}, //2.2.5.6 资源库资源访问情况

      countryZykActiveResourceRank: [], //2.2.6.1 资源量排名
      zykLogRankList: [], //2.2.6.2 访问量排名
      zykActiveUserRankList: [], //2.2.6.3 活跃用户数排名

      //3
      CourseYearRunAnalysis: {
        onlineCourseLevelNums: [],
        OnlineCourseCoreIndicatorStat: {
          value: [],
        },
      },
      ProvinceBuildCourseNum: [], //3.1 各省建设课程数量
      //3.1 归属专业大类分布情况
      BigClassCourseNum: {
        dataList: [],
      },
      //3.2
      OnlineCourseVisitNum: {
        onlineCourseVisitRank: [],
      },
      //3.3
      OnlineCourseOpenNum: {
        onlineCourseOpenRank: [],
      },
      //3.4
      OnlineCourseSelectNum: {
        onlineCourseSelectRank: [],
      },

      //4
      VideoCourseRunAnalysis: {
        videoCourseNunForType: {
          value: [],
          videoCourseCoreIndicator: {},
        },
      },
      //4.1
      ProvinceVideoCourseBuild: {
        videoCourseProvinceRank: [],
      },
      //4.2
      VideoCourseVisit: {
        videoCourseVisitRank: [],
      },
      //4.3
      VideoCourseSelect: {
        videoCourseSelectRank: [],
      },
      // 附件数据
      allProfessionAnalysisTableList: {
        装备制造大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        交通运输大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        财经商贸大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        电子与信息大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        土木建筑大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        农林牧渔大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },

        文化艺术大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        医药卫生大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        轻工纺织大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        能源动力与材料大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        食品药品与粮食大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        旅游大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },

        资源环境与安全大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        生物与化工大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        公共管理与服务大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        教育与体育大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        公安与司法大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        水利大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        新闻传播大类: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
        其他: {
          totalVisit: 0,
          totalUser: 0,
          student: 0,
          teacher: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
          value: [],
        },
      },

      loading: "", // 是否导出加载中
      nowYear: null, //当前年
      nowMonth: "", //当前月
      nowDay: "", //当前日
      detailYearWord: "", //当前具体时间描述
      startDay: "", //今年开始时间
      endDay: "", //去年结束时间
      laststartDay: "", //去年开始时间
      lastendDay: "", //去年结束时间
      reportType: null, //当前报告类型
    };
  },
  watch: {
    completeMathodNum(val) {
      console.log(val);
    },
  },
  mounted() {
    if (this.$route.query) {
      const { token } = this.$route.query;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.$route.query.endDay.slice(0, 4);
      this.laststartDay = this.startDay.replaceAll(
        this.nowYear,
        this.nowYear - 1
      );
      this.lastendDay = this.endDay.replaceAll(this.nowYear, this.nowYear - 1);
      sessionStorage.setItem("lrmv2token", token);
      const { zykid } = this.$route.query;
      sessionStorage.setItem("zykId", zykid);
      this.reportType = this.$route.query.type;
      if (this.reportType == 1) this.detailYearWord = "年";
      else if (this.reportType == 2) this.detailYearWord = "年上半年";
    }
    this.nowDate(); //   获取当前时间日期

    this.getCountryZykTeacherUserVisitCase_Fun(); // 2.1.6.4 国家级资源库用户访问情况-教师用户
    this.getCountryZykEnterpriseUserVisitCase_Fun(); // 2.1.6.4 国家级资源库用户访问情况-企业用户
    this.getCountryZykSocietyUserVisitCase_Fun(); // 2.1.6.4 国家级资源库用户访问情况-社会学习者

    this.getCountryZykCourseVisitCase_Fun(); // 2.1.6.5 国家级资源库课程访问情况

    this.getCountryZykResourceVisitCase_Fun(); // 2.1.6.6 国家级资源库资源访问情况

    this.getYearReportCountryZykActiveResourceRank_Fun(); // 2.1.7.1 按资源量维度排名

    this.getCountryZykBuildAnalysisLogRank_Fun(); // 2.1.7.2 按访问量维度排名

    this.getYearReportCountryZykActiveUserRank_Fun(); // 2.1.7.3 按活跃用户数排名

    this.getCompositeRank_Fun(); // 2.1.7.4 2022年综合应用排行排名

    this.getCountryProvinceCitySchoolLevelProfessionZykRunCase_Fun(); // 2.2 国家及省市校级专业教学资源库运行监测情况分析
    this.getPlatFormNumByType_fn(); // 获取平台数

    this.getUserBuildAndAnalysis_Fun(); // 2.2.1 用户建设及应用情况

    this.getCourseBuildAndAnalysis_Fun(); // 2.2.2 课程建设及应用情况

    this.getResourceBuildAndAnalysis_Fun(); // 2.2.3 资源建设及应用

    this.getProvinceZykBuildAndAnalysis_Fun(); // 2.2.4.1 各省资源库建设及应用情况概览
    this.getProvinceUserBuildAndAnalysis_Fun(); // 2.2.4.2 各省用户建设及应用情况
    this.getProvinceCourseBuildAndAnalysis_Fun(); // 2.2.4.3 各省课程建设及应用情况
    this.getProvinceZyBuildAndAnalysis_Fun(); // 2.2.4.4 各省资源建设及应用情况

    this.getZykStudentUserNewAddCase_Fun(); // 2.2.5.1 资源库用户新增情况-学生用户
    this.getZykTeacherUserNewAddCase_Fun(); // 2.2.5.1 资源库用户新增情况-教师用户
    this.getZykEnterpriseUserNewAddCase_Fun(); // //2.2.5.1 资源库用户新增情况-企业用户
    this.getZykSocietyUserNewAddCase_Fun(); // 2.2.5.1 资源库用户新增情况-社会学习者

    this.getZykResourceNewAddCase_Fun(); // 2.2.5.2 资源库资源新增情况

    this.getZykCourseNewAddCase_Fun(); // 2.2.5.3 资源库课程新增情况

    this.getZykStudentUserVisitCase_Fun(); // 2.2.5.4 资源库用户访问情况-学生用户
    this.getZykTeacherUserVisitCase_Fun(); // 2.2.5.4 资源库用户访问情况-教师用户
    this.getZykEnterpriseUserVisitCase_Fun(); // 2.2.5.4 资源库用户访问情况-企业用户
    this.getZykSocietyUserVisitCase_Fun(); // 2.2.5.4 资源库用户访问情况-社会学习者
    this.getZykVisitCaseTotalByType(); //2.2.5.4 获取累计登录用户和累计点击数

    this.getZykCourseVisitCase_Fun(); //2.2.5.5 资源库课程访问情况

    this.getZykResourceVisitCase_Fun(); //2.2.5.6 资源库资源访问情况

    this.getYearReportZykActiveResourceRank_Fun(); //2.2.6.1 资源量排名

    this.getZykBuildAnalysisLogRank_Fun(); //2.2.6.2 访问量排名

    this.getYearReportZykActiveUserRank_Fun(); //2.2.6.3 活跃用户数排名

    this.getOnlineCourseYearRunAnalysis_Fun(); //3
    this.getProvinceBuildCourseNum_Fun(); //3.1 各省建设课程数量
    this.getProfessionBigClassCourseNum_Fun(); //3.1 归属专业大类分布情况
    this.getOnlineCourseVisitNum_Fun(); //3.2
    this.getOnlineCourseOpenNum_Fun(); //3.3
    this.getOnlineCourseSelectNum_Fun(); //3.4

    this.getVideoCourseRunAnalysis_Fun(); //4
    this.getProvinceVideoCourseBuild_Fun(); //4.1
    this.getVideoCourseVisit_Fun(); //4.2
    this.getVideoCourseSelect_Fun(); //4.3

    this.getAllProfessionAnalysisTable(); //获取附件数据
  },

  methods: {
    changeCity(val) {
      val = val.replace("省", "").replace("市", "");
      if (
        val === "北京" ||
        val === "重庆" ||
        val === "天津" ||
        val === "上海"
      ) {
        return val + "市";
      } else return val + "省";
    },

    getReduceOrAdd(num) {
      const data =
        num > 0
          ? "增加" + this.getUtils_Fun(num)
          : "减少" + this.getUtils_Fun(Math.abs(num));
      return data;
    },

    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },

    formatValue(num) {
      return num.toFixed(0);
    },

    // 截取当前日期的赋值操作
    nowDate() {
      const Frist = this.$route.query.endDay.indexOf("-") + 1;
      const last = this.$route.query.endDay.lastIndexOf("-") + 1;
      const regx = /^[0]+/;
      this.nowMonth = this.$route.query.endDay
        .slice(Frist, last - 1)
        .replace(regx, "");
      this.nowDay = this.$route.query.endDay.slice(
        last,
        this.$route.query.endDay.length
      );
    },

    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post(
          this.$apiurls.exportMonthReport,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        })
        .catch(() => {
          this.loading.close();
        });
    },

    // 2.1.6.4 国家级资源库用户访问情况-教师用户
    getCountryZykTeacherUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykTeacherUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykTeacherUserVisitCase = res.data;
          this.ZykTeacherUserVisitCase.firstTotal =
            res.data.firstTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.ZykTeacherUserVisitCase.secondTotal =
            res.data.secondTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.ZykTeacherUserVisitCase.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.4 国家级资源库用户访问情况-企业用户
    getCountryZykEnterpriseUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykEnterpriseUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykEnterpriseUserVisitCase = res.data;
          this.ZykEnterpriseUserVisitCase.firstTotal =
            res.data.firstTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.ZykEnterpriseUserVisitCase.secondTotal =
            res.data.secondTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.ZykEnterpriseUserVisitCase.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.4 国家级资源库用户访问情况-社会学习者
    getCountryZykSocietyUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykSocietyUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykSocietyUserVisitCase = res.data;
          this.ZykSocietyUserVisitCase.firstTotal =
            res.data.firstTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.ZykSocietyUserVisitCase.secondTotal =
            res.data.secondTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.ZykSocietyUserVisitCase.dataList = [
            res.data.secondTimeSocietyNum,
            res.data.firstTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.5 国家级资源库课程访问情况
    getCountryZykCourseVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykCourseVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykCourseVisitCase = res.data;
          this.ZykCourseVisitCase.firstTotal =
            res.data.firstTimeCourseNum.reduce((a, b) => a + b, 0);
          this.ZykCourseVisitCase.secondTotal =
            res.data.secondTimeCourseNum.reduce((a, b) => a + b, 0);
          this.ZykCourseVisitCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.6 国家级资源库资源访问情况
    getCountryZykResourceVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykResourceVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykResourceVisitCase = res.data;
          this.ZykResourceVisitCase.firstTotal =
            res.data.firstTimeResourceNum.reduce((a, b) => a + b, 0);
          this.ZykResourceVisitCase.secondTotal =
            res.data.secondTimeResourceNum.reduce((a, b) => a + b, 0);
          this.ZykResourceVisitCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.7.1 按资源量维度排名
    getYearReportCountryZykActiveResourceRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportCountryZykActiveResourceRank, {
          loading: false,
        })
        .then((res) => {
          this.sourceMater2171.dataList = res.data.value;
          this.sourceMater2171.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.7.2 按访问量维度排名
    getCountryZykBuildAnalysisLogRank_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykBuildAnalysisLogRank, {
          loading: false,
        })
        .then((res) => {
          this.sourceMater2172.dataList = res.data.value;
          this.sourceMater2172.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.7.3 按活跃用户数排名
    getYearReportCountryZykActiveUserRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportCountryZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.sourceMater2173.dataList = res.data.value;
          this.sourceMater2173.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.7.4 2022年综合应用排行排名
    getCompositeRank_Fun() {
      this.$axios
        .post(this.$apiurls.getCompositeRank, {
          loading: false,
        })
        .then((res) => {
          const firstChargeUnit1 = res.data.topFifteenRankList.firstChargeUnit;
          const zykName1 = res.data.topFifteenRankList.zykName;
          const zykNum1 = res.data.topFifteenRankList.zykNum;
          const firstChargeUnit2 = res.data.lastFifteenRankList.firstChargeUnit;
          const zykName2 = res.data.lastFifteenRankList.zykName;
          const zykNum2 = res.data.lastFifteenRankList.zykNum;
          this.disksNum_top = firstChargeUnit1.map((item, index) => {
            item = {
              firstChargeUnit: item,
              zykName: zykName1[index],
              zykNum: zykNum1[index],
            };
            return item;
          });
          this.disksNum_last = firstChargeUnit2.map((item, index) => {
            item = {
              firstChargeUnit: item,
              zykName: zykName2[index],
              zykNum: zykNum2[index],
            };
            return item;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2 国家及省市校级专业教学资源库运行监测情况分析
    getCountryProvinceCitySchoolLevelProfessionZykRunCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryProvinceCitySchoolLevelProfessionZykRunCase,
          {
            loading: false,
          }
        )
        .then((res) => {
          this.runCase = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 获取平台数
    getPlatFormNumByType_fn() {
      this.$axios
        .post(this.$apiurls.getPlatFormNumByType, { loading: false })
        .then((res) => {
          if (res.code === 200) {
            this.platformNum = res.data;
          }
        });
    },
    // 2.2.1 用户建设及应用情况
    getUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.analysis = res.data;
          const usernameArr = [
            "企业用户",
            "其他",
            "社会学习者",
            "学生",
            "教师",
          ];
          const list = ["enterprise", "other", "social", "student", "teacher"];
          delete this.analysis.userMap.sum;
          this.analysis.userMap = usernameArr.map((item, index) => {
            item = {
              name: item,
              value: this.analysis.userMap[list[index]],
            };
            return item;
          });
          let sum = 0;
          this.analysis.studentType.forEach((item) => {
            sum += +item.value;
          });
          this.analysis.studentTotal = sum;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.2 课程建设及应用情况
    getCourseBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCourseBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.courseBuild = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.3 资源建设及应用
    getResourceBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getResource = res.data;
          this.getResource.visitMaxResource.name =
            this.getResource.visitMaxResource.name.split(",")[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.4.1 各省资源库建设及应用情况概览
    getProvinceZykBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceZykBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getProvince = res.data;
          let arr = res.data.zykProvinceClassify;
          for (const item of arr) {
            this.provinceAmount.zykCount += +item.zykCount;
            this.provinceAmount.resourceCount += +item.resourceCount;
            this.provinceAmount.courseCount += +item.courseCount;
            this.provinceAmount.userCount += +item.userCount;
            this.provinceAmount.totalActiveTeacherNum +=
              +item.totalActiveTeacherNum;
            this.provinceAmount.totalActiveStudentNum +=
              +item.totalActiveStudentNum;
            this.provinceAmount.logNum += +item.logNum;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.4.2 各省用户建设及应用情况
    getProvinceUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getProvinceUser = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.4.3 各省课程建设及应用情况
    getProvinceCourseBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.CourseBuildAndAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.4.4 各省资源建设及应用情况
    getProvinceZyBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceZyBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.ZyBuildAndAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.1 资源库用户新增情况-学生用户
    getZykStudentUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykStudentUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykStudentUserNewAddCase = res.data;
          this.ZykStudentUserNewAddCase.secondTotal =
            res.data.studentSecondTimeNum.reduce((a, b) => a + b, 0);
          this.ZykStudentUserNewAddCase.dataList = [
            res.data.studentSecondTimeNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.1 资源库用户新增情况-教师用户
    getZykTeacherUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykTeacherUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [1],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykTeacherUserNewAddCase = res.data;
          this.ZykTeacherUserNewAddCase.secondTotal =
            res.data.secondTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.ZykTeacherUserNewAddCase.dataList = [
            res.data.secondTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // //2.2.5.1 资源库用户新增情况-企业用户
    getZykEnterpriseUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykEnterpriseUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykEnterpriseUserNewAddCase = res.data;
          this.ZykEnterpriseUserNewAddCase.secondTotal =
            res.data.secondTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.ZykEnterpriseUserNewAddCase.dataList = [
            res.data.secondTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.1 资源库用户新增情况-社会学习者
    getZykSocietyUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykSocietyUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [3],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykSocietyUserNewAddCase = res.data;
          this.ZykSocietyUserNewAddCase.secondTotal =
            res.data.secondTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.ZykSocietyUserNewAddCase.dataList = [
            res.data.secondTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.2 资源库资源新增情况
    getZykResourceNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [6],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykResourceNewAddCase = res.data;
          let secondTimeResourceNum = res.data.secondTimeResourceNum;
          this.getZykResourceNewAddCase.secondTotal =
            secondTimeResourceNum.reduce((a, b) => a + b, 0);
          this.getZykResourceNewAddCase.dataList = [secondTimeResourceNum];
          let data = res.data.resourceDistribution;
          this.getZykResourceNewAddCase.resourceDistribution = [
            {
              name: "视频",
              value: data.video,
            },
            {
              name: "图形图像",
              value: data.image,
            },
            {
              name: "文本",
              value: data.text,
            },
            {
              name: "PPT和富媒体",
              value: data.ppt + data.media + data.courseware,
            },
            {
              name: "动画",
              value: data.animation,
            },
            {
              name: "微课",
              value: data.microCourses,
            },
            {
              name: "音频",
              value: data.audio,
            },
            {
              name: "虚拟仿真",
              value: data.simulation,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.3 资源库课程新增情况
    getZykCourseNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykCourseNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [5],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          let secondTimeCourseNum = res.data.secondTimeCourseNum;
          this.getZykCourseNewAddCase = res.data;
          this.getZykCourseNewAddCase.secondTotal = secondTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykCourseNewAddCase.dataList = [secondTimeCourseNum];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.4 资源库用户访问情况-学生用户
    getZykStudentUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykStudentUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykStudentUserVisitCase = res.data;
          this.getZykStudentUserVisitCase.secondTotal =
            res.data.secondTimeStudentNum.reduce((a, b) => a + b, 0);
          this.getZykStudentUserVisitCase.dataList = [
            res.data.secondTimeStudentNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.4 资源库用户访问情况-教师用户
    getZykTeacherUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykTeacherUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykTeacherUserVisitCase = res.data;
          this.getZykTeacherUserVisitCase.secondTotal =
            res.data.secondTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.getZykTeacherUserVisitCase.dataList = [
            res.data.secondTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.4 资源库用户访问情况-企业用户
    getZykEnterpriseUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykEnterpriseUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykEnterpriseUserVisitCase = res.data;
          this.getZykEnterpriseUserVisitCase.secondTotal =
            res.data.secondTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.getZykEnterpriseUserVisitCase.dataList = [
            res.data.secondTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.2.5.4 资源库用户访问情况-社会学习者
    getZykSocietyUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykSocietyUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykSocietyUserVisitCase = res.data;
          this.getZykSocietyUserVisitCase.secondTotal =
            res.data.secondTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.getZykSocietyUserVisitCase.dataList = [
            res.data.secondTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.5.4 获取累计登录用户和累计点击数
    getZykVisitCaseTotalByType() {
      this.$axios
        .post(
          this.$apiurls.getZykVisitCaseTotalByType,
          {
            fistStartTime: this.$route.query.startDay,
            fistEndTime: this.$route.query.endDay,
            types: [1, 2, 3, 4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zykTotalVisit = res.data.totalVisitNum;
          this.allLevelTotalLoginUserNum = res.data.allLevelTotalLoginUserNum;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.5.5 资源库课程访问情况
    getZykCourseVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykCourseVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [5],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykCourseVisitCase = res.data;
          this.getZykCourseVisitCase.secondTotal =
            res.data.secondTimeCourseNum.reduce((a, b) => a + b, 0);
          this.getZykCourseVisitCase.dataList = [res.data.secondTimeCourseNum];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.5.6 资源库资源访问情况
    getZykResourceVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [6],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.getZykResourceVisitCase = res.data;
          this.getZykResourceVisitCase.secondTotal =
            res.data.secondTimeResourceNum.reduce((a, b) => a + b, 0);
          this.getZykResourceVisitCase.dataList = [
            res.data.secondTimeResourceNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.6.1 资源量排名
    getYearReportZykActiveResourceRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportZykActiveResourceRank, {
          loading: false,
        })
        .then((res) => {
          this.countryZykActiveResourceRank =
            res.data.countryZykActiveResourceRank;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.6.2 访问量排名
    getZykBuildAnalysisLogRank_Fun() {
      this.$axios
        .post(this.$apiurls.getZykBuildAnalysisLogRank, {
          loading: false,
        })
        .then((res) => {
          this.zykLogRankList = res.data.zykLogRankList;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.2.6.3 活跃用户数排名
    getYearReportZykActiveUserRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.zykActiveUserRankList = res.data.zykActiveUserRankList;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3
    getOnlineCourseYearRunAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseYearRunAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.CourseYearRunAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3.1 各省建设课程数量
    getProvinceBuildCourseNum_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceBuildCourseNum, {
          loading: false,
        })
        .then((res) => {
          this.ProvinceBuildCourseNum = res.data.onlineCourseRankByProvince.map(
            (item) => {
              item = {
                name: item.province,
                value: item.total,
              };
              return item;
            }
          );
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3.1 归属专业大类分布情况
    getProfessionBigClassCourseNum_Fun() {
      this.$axios
        .post(this.$apiurls.getProfessionBigClassCourseNum, {
          loading: false,
        })
        .then((res) => {
          let total = 0;
          res.data.onlineCourseCategoryBuild.forEach((item) => {
            total += item.value;
          });
          this.BigClassCourseNum.total = total;
          this.BigClassCourseNum.dataList = res.data.onlineCourseCategoryBuild;
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          this.BigClassCourseNum.dataList.sort(Sort);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3.2
    getOnlineCourseVisitNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseVisitNum, {
          loading: false,
        })
        .then((res) => {
          this.OnlineCourseVisitNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3.3
    getOnlineCourseOpenNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseOpenNum, {
          loading: false,
        })
        .then((res) => {
          this.OnlineCourseOpenNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //3.4
    getOnlineCourseSelectNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseSelectNum, {
          loading: false,
        })
        .then((res) => {
          this.OnlineCourseSelectNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //4
    getVideoCourseRunAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseRunAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.VideoCourseRunAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //4.1
    getProvinceVideoCourseBuild_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceVideoCourseBuild, {
          loading: false,
        })
        .then((res) => {
          this.ProvinceVideoCourseBuild = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //4.2
    getVideoCourseVisit_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseVisit, {
          loading: false,
        })
        .then((res) => {
          this.VideoCourseVisit = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //4.3
    getVideoCourseSelect_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseSelect, {
          loading: false,
        })
        .then((res) => {
          this.VideoCourseSelect = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 获取附件数据
    getAllProfessionAnalysisTable() {
      this.$axios
        .post(
          this.$apiurls.getAllProfessionAnalysisTable,
          {},
          { loading: false }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.data;
            for (const key in this.allProfessionAnalysisTableList) {
              for (const item of data) {
                if (key === item.name) {
                  this.allProfessionAnalysisTableList[key].value = item.value;
                  this.allProfessionAnalysisTableList[key].totalVisit = 0;
                  this.allProfessionAnalysisTableList[key].totalUser = 0;
                  this.allProfessionAnalysisTableList[key].student = 0;
                  this.allProfessionAnalysisTableList[key].teacher = 0;
                  this.allProfessionAnalysisTableList[key].totalResource = 0;
                  this.allProfessionAnalysisTableList[key].standardCourse = 0;
                  this.allProfessionAnalysisTableList[key].totalCourse = 0;
                  for (const obj of item.value) {
                    this.allProfessionAnalysisTableList[key].totalVisit +=
                      +obj.totalVisit;
                    this.allProfessionAnalysisTableList[key].totalUser +=
                      +obj.totalUser;
                    this.allProfessionAnalysisTableList[key].student +=
                      +obj.activeStudentNum;
                    this.allProfessionAnalysisTableList[key].teacher +=
                      +obj.activeTeacherNum;
                    this.allProfessionAnalysisTableList[key].totalResource +=
                      +obj.totalResource;
                    this.allProfessionAnalysisTableList[key].standardCourse +=
                      +obj.standardCourse;
                    this.allProfessionAnalysisTableList[key].totalCourse +=
                      +obj.totalCourse;
                  }
                }
              }
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 86.7%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 40px;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0 60px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  position: relative;
  clear: both;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0;
}

.chart_box {
  width: 100%;
  height: auto;
  clear: both;
}
.chart_box,
.catalogue h3 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
  line-height: 40px;
}

.catalogue h3 {
  margin-top: 50px;
  margin-bottom: 15px;
}

.chart_box h3 {
  font-size: 50px;
  margin-top: 30px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
}

.catalogue h4 {
  margin-top: 50px;
  margin-bottom: 15px;
}
.chart_box h4 {
  font-size: 42px;
  margin-bottom: 35px;
  margin-top: 30px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 30px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
}

.catalogue h5 {
  margin-top: 50px;
  margin-bottom: 15px;
}
.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
  margin-top: 30px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 39px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 35px;
  margin-top: 30px;
}
.chart_box p {
  font-weight: 540;
  font-size: 35px;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f;
}

.chart_box .echartsHeight,
.layout,
.speed {
  /* width: 80%; */
  /* height: calc(100vw / 1080 * 300); */
  height: 28rem;
  /* height: 400px; */
  /* margin: 10px auto 0px; */
  /* margin: 0px auto; */
  /* flex: 1; */
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
  margin-top: 20px;
}

.chart_box .notes {
  margin: 35px 0;
  line-height: 50px;
  font-size: 30px;
  color: black;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}
.biaoge {
  /* height: 720px; */
  font-weight: 540 !important;
  width: 100%;
  margin: 25px auto;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 22px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}
::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-top: 20%;
  padding-left: 10%;
}

.HomePage #image {
  width: 700px;
  height: 150px;
  background: url("../../../../public/pdf.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 45% 0px 40% 0px;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 55px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 4.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  padding: 10% 0px 0px 10%;
  margin-top: 300px;
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}
.top {
  margin-top: 140px;
}
</style>
<style lang="scss" scoped>
.page-box {
  padding: 7% 0;
  height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // border: 1px solid red;
}
.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.m-top70 {
  margin-top: 70px !important;
}
.m-top100 {
  margin-top: 100px !important;
}
.m-top150 {
  margin-top: 150px !important;
}
.annex-table {
  tr {
    td,
    th {
      padding: 0 5px;
    }
    th:not(:nth-of-type(3)),
    td:not(:nth-of-type(3)) {
      white-space: nowrap;
    }
  }
}
</style>
